const padZero = (n: number) => n?.toString().padStart(2, "0");
export enum DateDisplayFormats {
  date = "dd/MM/yyyy",
  time = "hh:mm aa",
  data_time = "dd/MM/yyyy - hh:mm aa",
}
export enum DateServerFormats {
  date = "yyyy-MM-dd",
  time = "hh:mm",
  data_time = "yyyy-MM-dd hh:mm",
}
export const secondsToMS = (seconds: number) =>
  `${padZero(Math.floor(seconds / 60))}:${padZero(Math.floor(seconds % 60))}`;

export const getDate = (date: Date) =>
  date ? `${padZero(date.getFullYear())}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())}` : null;

export const getTime = (date: Date) => (date ? `${padZero(date.getHours())}:${padZero(date.getMinutes())}` : null);

export const convertToDate = (s: string, format: string) => {
  if (!s) return undefined;
  const normalized = s.replace(/[^a-zA-Z0-9]/g, "-");
  const dateItems = normalized.split("-");

  const normalizedFormat = format.replace(/[^a-zA-Z0-9]/g, "-");
  const formatItems = normalizedFormat.split("-");

  const monthIndex = formatItems.indexOf("MM");
  const dayIndex = formatItems.indexOf("dd");
  const yearIndex = formatItems.indexOf("yyyy");
  const hourIndex = formatItems.indexOf("hh");
  const minutesIndex = formatItems.indexOf("mm");
  const secondsIndex = formatItems.indexOf("ss");

  const today = new Date();

  const year = yearIndex > -1 ? +dateItems[yearIndex] : today.getFullYear();
  const month = monthIndex > -1 ? +dateItems[monthIndex] - 1 : today.getMonth() - 1;
  const day = dayIndex > -1 ? +dateItems[dayIndex] : today.getDate();

  const hour = hourIndex > -1 ? +dateItems[hourIndex] : today.getHours();
  const minute = minutesIndex > -1 ? +dateItems[minutesIndex] : today.getMinutes();
  const second = secondsIndex > -1 ? +dateItems[secondsIndex] : today.getSeconds();

  return new Date(year, month, day, hour, minute, second);
};
